// extracted by mini-css-extract-plugin
export default {"root":"_2fpKg","thumb":"_1Kw6O","selected":"AMcLG"};